import { useMemo } from 'react';
import useProfile from '@/hooks/useProfileV2';
import TopPageLinksComponent, { PageLink, TopPageLinksProps } from './TopPageLinks.component';

const TopPageLinks = ({ pageLinks, ...props }: TopPageLinksProps): JSX.Element => {
  const { profile } = useProfile();

  const allowedPageLinks = useMemo((): PageLink[] => {
    if (!profile.roles) {
      return [];
    }

    let userPermissions: string[] = [];

    profile.roles.forEach((role) => {
      const rolePermissionValues = role.permissions.map((permission) => permission.value);
      userPermissions = [...userPermissions, ...rolePermissionValues];
    });

    return pageLinks.filter((link) => {
      const artifact = `web:${link.to.path}`;
      if (userPermissions.includes(artifact)) return true;
      // Also check legacy paths for backwards compatibility
      const legacyPath = link.to.path.replace('/talentx/', '/hiring/').replace('/peoplex/', '/people/');
      return userPermissions.includes(`web:${legacyPath}`);
    });
  }, [pageLinks, profile.roles]);

  return <TopPageLinksComponent pageLinks={allowedPageLinks} {...props} />;
};

export default TopPageLinks;
